var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMegaphone = function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#212121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0238 2.03534C15.9968 1.20133 17.5 1.89269 17.5 3.17422V18.8258C17.5 20.1073 15.9968 20.7987 15.0238 19.9647L9.81504 15.5H4C2.61929 15.5 1.5 14.3807 1.5 13V9C1.5 7.61929 2.61929 6.5 4 6.5H9.81504L15.0238 2.03534ZM16.5 3.17422C16.5 2.74705 15.9989 2.51659 15.6746 2.7946L10.185 7.5H4C3.17157 7.5 2.5 8.17158 2.5 9V13C2.5 13.8284 3.17157 14.5 4 14.5H10.185L15.6746 19.2054C15.9989 19.4834 16.5 19.253 16.5 18.8258V3.17422Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0754 6.12418C21.3114 6.36019 21.3114 6.74285 21.0754 6.97886L19.6859 8.36833C19.4499 8.60434 19.0673 8.60434 18.8313 8.36833C18.5953 8.13231 18.5953 7.74966 18.8313 7.51364L20.2207 6.12418C20.4567 5.88817 20.8394 5.88817 21.0754 6.12418Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2769 11.4391C23.2769 11.7729 23.0063 12.0435 22.6725 12.0435H20.7075C20.3737 12.0435 20.1032 11.7729 20.1032 11.4391C20.1032 11.1054 20.3737 10.8348 20.7075 10.8348H22.6725C23.0063 10.8348 23.2769 11.1054 23.2769 11.4391Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0753 16.7541C20.8393 16.9901 20.4567 16.9901 20.2207 16.7541L18.8312 15.3647C18.5952 15.1286 18.5952 14.746 18.8312 14.51C19.0672 14.274 19.4499 14.274 19.6859 14.51L21.0753 15.8994C21.3114 16.1355 21.3114 16.5181 21.0753 16.7541Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.5H8.5V20.5C8.5 21.6046 7.60457 22.5 6.5 22.5C5.39543 22.5 4.5 21.6046 4.5 20.5V14.5ZM5.5 15.5V20.5C5.5 21.0523 5.94772 21.5 6.5 21.5C7.05228 21.5 7.5 21.0523 7.5 20.5V15.5H5.5Z"
  })));
};
export default SvgMegaphone;